import { useState } from 'react'
import { Box, Typography, Fade } from '@mui/material'
import 'swiper/css'
import vipBanner1 from '../assets/vip/vip-banner-1.png'

import 'swiper/css'
import 'swiper/css/autoplay'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper'
const banners = [
  // { src: vipBanner1, code: "vipBanner1" },
  { src: vipBanner1, code: 'vipBanner2' },
  // { src: vipBanner1, code: "vipBanner3" },
]

const bannerText = [
  {
    title: 'JETPOT VIP PROGRAM',
    desc: 'Beyond loyalty. JETPOT VIP is your first-class upgrade to a world of platinum-tier rewards, priority service, and the refined luxury of a private cabin experience - a program crafted for those who fly above the ordinary.',
  },
  // {
  //   title: "jetpot VIP PROGRAM",
  //   desc: "Be part of something special. jetpot VIP program is designed for those who demand the best. Exclusivity, premium rewards, and top-notch customer support—all in one place. Enroll today and experience loyalty, redefined.",
  // },
  // {
  //   title: "jetpot VIP PROGRAM",
  //   desc: "Be part of something special. jetpot VIP program is designed for those who demand the best. Exclusivity, premium rewards, and top-notch customer support—all in one place. Enroll today and experience loyalty, redefined.",
  // },
]

const BannerSection = () => {
  const [active, setActive] = useState(0)

  return (
    <>
      <Box sx={{ position: 'relative', height: { xs: 260, md: 420 } }}>
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000 }}
          // loop
          onSlideChange={(swiper) => setActive(swiper.realIndex)}
          style={{ height: '100%' }}
        >
          {banners.map((b) => (
            <SwiperSlide key={b.code}>
              <Box
                component="img"
                src={b.src}
                alt={b.code}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: { xs: 'left', md: 'none' },
                  aspectRatio: { xs: '6/4', md: 'unset' },
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            alignItems: { xs: 'flex-end', md: 'center' },
            justifyContent: { xs: 'center', md: 'flex-end' },
            p: { xs: 2, md: 6 },
            pointerEvents: 'none',
            zIndex: 1300,

            display: { xs: 'none', md: 'flex' },
          }}
        >
          <Fade key={active} in timeout={500}>
            <Box maxWidth={420} textAlign={{ xs: 'center', md: 'left' }}>
              <Typography
                variant="h4"
                fontWeight="bold"
                mb={1}
                sx={{
                  color: '#2229D5',

                  textTransform: 'uppercase',
                  position: 'relative',
                  display: 'inline-block',
                  fontSize: '2.25rem',
                  textShadow: `
                      -1px -1px 0 #ffff,
                       1px -1px 0 #ffff,
                      -1px  1px 0 #ffff,
                       1px  1px 0 #ffff,0px 3px 2px #6a6a6a
                    `,
                }}
              >
                {bannerText[active].title}
              </Typography>
              <Typography variant="body2" sx={{ color: '#454545', textTransform: 'uppercase' }}>
                {bannerText[active].desc}
              </Typography>
            </Box>
          </Fade>
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: 'flex', md: 'none' },
          flexDirection: 'column',
          px: 4,
        }}
        textAlign={{ xs: 'center', md: 'left' }}
        mt={4}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          mb={2}
          sx={{
            color: '#2229D5',

            textTransform: 'uppercase',
            position: 'relative',
            display: 'inline-block',
            fontSize: '1.85rem',
            textShadow: `
                      -1px -1px 0 #ffff,
                       1px -1px 0 #ffff,
                      -1px  1px 0 #ffff,
                       1px  1px 0 #ffff,0px 3px 2px #6a6a6a
                    `,
          }}
        >
          {bannerText[active].title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'primary.main', textTransform: 'uppercase' }}>
          {bannerText[active].desc}
        </Typography>
      </Box>
    </>
  )
}

export default BannerSection
